import { render, staticRenderFns } from "./tmc-marker.vue?vue&type=template&id=055649fa&scoped=true"
import script from "./tmc-marker.vue?vue&type=script&lang=js"
export * from "./tmc-marker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055649fa",
  null
  
)

export default component.exports